import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['item'];

    connect() {
        if (this.itemTargets.length === 0) {
            return;
        }

        document.documentElement.classList.add('reveal-ready');

        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.itemTargets.forEach((item) => item.classList.add('is-visible'));
            return;
        }

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
            });
        }, {rootMargin: '0px 0px -10% 0px', threshold: 0.12});

        this.itemTargets.forEach((item) => this.observer.observe(item));
    }

    disconnect() {
        this.observer?.disconnect();
    }
}
